export const MANTLE_MARK_VIEWBOX_SIZE = 612.84;

export const MANTLE_MARK_PATH =
  'M473.21,305.93c77.43-8.74,137.05-76.29,133.02-156.94-3.81-76.4-65.96-138.55-142.36-142.37-80.65-4.03-148.2,55.58-156.95,133.01-.07.61-.92.61-.99,0C297.18,62.2,229.63,2.59,148.97,6.61,72.58,10.43,10.42,72.58,6.61,148.98c-4.02,80.65,55.59,148.2,133.02,156.95.61.07.61.92,0,.99C62.21,315.66,2.59,383.21,6.61,463.86c3.81,76.4,65.96,138.55,142.36,142.37,80.65,4.03,148.2-55.58,156.95-133.01.07-.61.92-.61.99,0,8.75,77.43,76.3,137.04,156.95,133.01,76.4-3.81,138.55-65.97,142.36-142.37,4.02-80.65-55.59-148.2-133.02-156.95-.61-.07-.61-.92,0-.99ZM305.93,439.14c-7.83-69.37-62.87-124.4-132.24-132.23-.61-.07-.61-.92,0-.99,69.37-7.82,124.41-62.86,132.24-132.23.07-.61.92-.61.98,0,7.83,69.37,62.87,124.4,132.24,132.23.61.07.61.92,0,.99-69.37,7.82-124.41,62.86-132.24,132.23-.07.61-.92.61-.98,0Z';

export const BRAND_COLOR = '#1c3c4a';

const roundToHundredths = (value: number): number => Math.round(value * 100) / 100;

/**
 * The mark in `BRAND_COLOR` as a transparent SVG data URI, for an `<img>` or a
 * favicon `<link>`. `insetRatio` leaves that share of the mark's width as room
 * on each side.
 */
export const mantleMarkSrc = ({ insetRatio = 0 }: { insetRatio?: number } = {}): string => {
  const inset = roundToHundredths(MANTLE_MARK_VIEWBOX_SIZE * insetRatio);
  const side = roundToHundredths(MANTLE_MARK_VIEWBOX_SIZE + inset * 2);
  const origin = inset === 0 ? '0' : `-${inset}`;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${origin} ${origin} ${side} ${side}" fill="none"><path d="${MANTLE_MARK_PATH}" fill="${BRAND_COLOR}"/></svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

/** The mark with room around it for a square avatar, whose own themed background shows behind it. */
export const MANTLE_MARK_TILE_SRC = mantleMarkSrc({ insetRatio: 0.3 });
